import {HTTPCodesEnum} from '@jetbrains/teamcity-ui/dist/services'

import {instanceOf} from './instanceOf'

type HTTPError = {
  statusCode?: number
}

type GraphQLErrorWithExtensions = Error & {
  extensions?: {classification?: string; [key: string]: unknown}
}

export default function getErrorStatusCode(error: unknown): number | null {
  if (instanceOf<HTTPError>(error, 'statusCode')) {
    return error.statusCode ?? null
  }

  if (instanceOf<GraphQLErrorWithExtensions>(error, 'extensions')) {
    const classification = error.extensions?.classification

    if (classification === 'NOT_FOUND') {
      return HTTPCodesEnum.NOT_FOUND
    }
    if (classification === 'ACCESS_DENIED') {
      return HTTPCodesEnum.FORBIDDEN
    }
    if (classification === 'SERVER_ERROR') {
      return HTTPCodesEnum.INTERNAL_SERVER_ERROR
    }
    if (classification === 'OPERATION_FAILED') {
      return HTTPCodesEnum.BAD_REQUEST
    }
  }

  return null
}
